import React from 'react';
import Certain from "../../../../components/Operation/Certain";
import DeadFish from '../../../../components/Operation/DeadFish';
import Delay from "../../../../components/Operation/Delay";
import Duration from "../../../../components/Operation/Duration";
import ExternalSite from "../../../../components/Operation/ExternalSite";
import FishDisease from "../../../../components/Operation/FishDisease";
import Id from "../../../../components/Operation/Id";
import InvoiceCount from '../../../../components/Operation/InvoiceCount';
import LiceList from "../../../../components/Operation/LiceList";
import Logo from "../../../../components/Operation/Logo";
import NameSpot from "../../../../components/Operation/NameSpot";
import NoteDetail from "../../../../components/Operation/NoteDetail";
import OperationStatus from "../../../../components/Operation/OperationStatus";
import SiteUnit from "../../../../components/Operation/SiteUnit";
import StatusGrading from '../../../../components/Operation/StatusGrading';
import Weather from "../../../../components/Operation/Weather";
import { OP_STATUS, OPERATION_TYPE, SITE_TYPE } from "../../../../util/varibles/constants";
import { IOperation, ITreatment2, TOperation2 } from "../../../../util/varibles/interface";
import { getTypesAndUnitOfTreatment } from "../../util";
import styles from "./style.module.scss";

interface IProps {
    data: IOperation
    isOwn: boolean
    status: OP_STATUS
}

const TreatmentView: React.FC<IProps> = ({ data, isOwn, status }) => {
    const { operation, activity_log } = data;
    const treatmentOperation = operation as ITreatment2;
    const totalFishAmount = (treatmentOperation.real_sub_operations ?? []).reduce(
        (total, subOperation) => total + (subOperation.fish_amount ?? 0),
        0,
    );
    const { tasks = [] } = operation || {};
    const { types } = getTypesAndUnitOfTreatment(tasks);
    return <>
        <div className={`${styles.title2} !overflow-visible`}>
            <div className={`${styles.right2} flex items-center justify-end`}>
                <ExternalSite {...{ type: operation.source_site_type === SITE_TYPE.EXTERNAL }} />
                <Weather {...{ visible: true, operation: operation as TOperation2 }} />
                <Delay visible={true} operation={operation} />
                {!isOwn && <NameSpot {...{ visible: true, operation }} />}
                <InvoiceCount operation={operation as TOperation2} />
            </div>
            {treatmentOperation.grading_status?.trim() && <div className={`${styles.right2} flex items-center justify-end pr-[2px] overflow-hidden [&>div]:!text-[15px] [&>div]:!font-[400] [&>div]:!leading-[22px]`}>
                <StatusGrading operation={treatmentOperation} />
            </div>}
            {typeof treatmentOperation.dead_fish === 'number' && <div className={`${styles.right2} overflow-hidden pr-[2px] [&>div]:h-full [&>div>span:first-child]:hidden`}>
                <DeadFish
                    value={treatmentOperation.dead_fish}
                    total={totalFishAmount}
                    valueClassName="text-[15px] !font-[400]"
                    showPercent={operation.status === OP_STATUS.FINISHED}
                />
            </div>}
            <div className={styles.left2}>
                <Logo type={OPERATION_TYPE.TREATMENT} status={status} />
                <Id {...{ visible: true, operation, status }} />
                <OperationStatus {...{ status }} />
                <Certain {...{ operation, status }} />
                <SiteUnit operation={operation} className={styles.siteUnitFlow} />
                <FishDisease diseases={operation.diseases || []} units={operation.sub_operations} wrapperClass={styles.section2} />
                <LiceList diseases={operation.diseases} short wrapperClass={styles.section2} />
                <div className={styles.section2}>
                    {Object.keys(types).map(key => types[key]).join(', ')}
                    <Duration {...{ status, activity_log }} />
                </div>
                <NoteDetail operation={operation} visible={true} />
            </div>
        </div>
    </>;
};

export default TreatmentView;
